import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

import Check from '../icon/regular/Check';
import Panel from '../ui/Panel';

export default function RefinementList({
  refinementList,
  refinementListSettings,
}: componentTypes.RefinementListPanelProps) {
  const { items, canRefine, refine } = refinementList;
  const { attribute, panelSettings } = refinementListSettings;
  const header = `${panelSettings?.header ?? attribute}`;

  if (!canRefine) {
    return null;
  }

  return (
    <Panel header={header}>
      <div className="flex flex-col gap-y-3 pt-1">
        {items.map((item, index) => (
          <label
            key={item.value}
            className="group/label flex gap-x-2 cursor-pointer text-base"
            htmlFor={`${attribute}.${index}`}
          >
            <span className="flex items-center justify-center shrink-0 w-8 h-8 border border-gray-300 rounded-sm text-pink-400 transition group-hover/label:border-pink-400">
              <Check className="w-4 fill-current opacity-0 group-has-checked/label:opacity-100" />
            </span>
            <div className="pt-1">
              {item.label}
              <span className="inline-block py-1 px-1.5 text-sm leading-none rounded-sm bg-white text-gray-350 ml-2">
                {item.count}
              </span>
            </div>
            <input
              id={`${attribute}.${index}`}
              className="absolute -z-10 opacity-0"
              type="checkbox"
              value={item.value}
              checked={item.isRefined}
              onChange={() => refine(item.value)}
            />
          </label>
        ))}
      </div>
    </Panel>
  );
}
